import { Text } from '@shared/components';
import { MovementTrackingPauseControl } from '@shared/features/shipment-card/MovementTrackingPauseControl';
import { TrackingPauseSource } from '@shared/generated/graphql';
import { MdRoute } from 'react-icons/md';
import { TrackedMovementFeedItem } from '../../types';

type TrackedMovementItemProps = {
  item: TrackedMovementFeedItem;
};

export function TrackedMovementItem({ item }: TrackedMovementItemProps) {
  const { movementId, referenceNumber, isPaused, onPausedChange } = item.data;
  const label = referenceNumber ?? movementId;

  return (
    <div className="mx-4 my-1 overflow-hidden rounded-lg border border-gray-200 bg-white shadow-sm">
      <div className="flex items-center justify-between gap-2 p-3">
        <div className="flex items-center gap-2 overflow-hidden">
          <div className="flex items-center justify-center rounded-md bg-gray-100 p-1 text-gray-600">
            <MdRoute size={14} />
          </div>
          <div className="flex min-w-0 flex-col">
            <Text isHeavy type="body-xs" className="truncate text-gray-700">
              Tracking {label}
            </Text>
            <Text
              type="body-xs"
              className={isPaused ? 'text-amber-600' : 'text-green-600'}
            >
              {isPaused ? 'Paused' : 'Active'}
            </Text>
          </div>
        </div>
        <MovementTrackingPauseControl
          movementId={movementId}
          isPaused={isPaused}
          source={TrackingPauseSource.EXTENSION}
          onPausedChange={onPausedChange}
        />
      </div>
    </div>
  );
}
